import axios from 'axios'
import {FETCH_ACTIVITY_LOG} from "@/services/RouteConstantsService";

export const ActivityLogService = {
    async fetchActivityLogs(params) {
        return await axios.post(FETCH_ACTIVITY_LOG, params)
    },
};

export default {ActivityLogService};